import styled, { css } from 'styled-components';

import { Link } from '@powdr/components';
import {
  ThemeProps as Prop, Breakpoints, FontFamily, FontSize,
} from '@powdr/constants';
import { getFontStyles, themeUtil } from '@powdr/utils';

export const StyledCountdownClock = styled.div`
  background-color: ${({ $backgroundColor }) => $backgroundColor};
  margin: 20px 0;
  padding: 15px;
  box-shadow: 0 2px 8px rgba(0, 0, 0, 0.3);
  text-align: center;
`;

export const ClockTitle = styled.h3`
  margin-bottom: 15px;
`;

export const ClockParts = styled.div`
  display: flex;
  align-items: center;
  justify-content: center;
  gap: 5%;

  ${Breakpoints.mobile(css`
    gap: 10%;
  `)}
`;

export const ClockPart = styled.div``;

export const Value = styled.div`
  ${() => getFontStyles(FontFamily.PRIMARY_FONT, FontSize.LRG20, undefined, undefined)};
`;

export const Label = styled.div`
  ${() => getFontStyles(FontFamily.BASE_FONT, FontSize.REG40, undefined, undefined)};
`;

export const Button = styled(Link)`
  margin: 15px 0 0 0 !important;
`;
